import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import {startLoadingSpinner, stopLoadingSpinner} from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import {CsfPivotalFournisseurDelegationTable} from "./csf-fournisseur-delegation-table";
import {CsfPivotalFournisseurDelegationModal} from "./csf-fournisseur-delegation-modal";
import {handleClickLinks, buildSearchConditionsContains, clearSearchBtn} from '../includes/utils';
import {CsfPivotalFournisseurDeleteModal} from "../includes/csf-fournisseur-delete-modal";
import PropTypes from "prop-types";

// import style
import './csf-fournisseur-delegation.scss';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";

export function CsfPivotalFournisseurDelegation({apiUrl, apiEnv, urlHome}) {

  const [accessToken, setAccessToken] = useState('');
  const [delegation, setDelegations] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [editDelegation, setEditDelegation] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const offset = 5;
  const [deleteType, setDeleteType] = useState('');
  const [deleteDelegation, setDeleteDelegation] = useState(false);
  const defaultContactDelegation = {
    'First_Name': "",
    'Last_Name': "",
    'GSFT_Correspondence_Language': 0,
    'Email': "",
    'EP_Contact_Role': 1,
    'GSFT_Status_Id': "AAAAAAAAADg=",
    'EP_Delegation_Deleted': false,
    'IPF_Matricule_Bridge':""
  }
  const [contactData, setContactData] = useState(defaultContactDelegation);
  const [ipfErrorMat, setIpfErrorMat] = useState(false);
  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    startLoadingSpinner();
    fetchAccessToken();
  }, []);

  /*
  * When the accessToken is fetched and state is updates, get the délégation list.
  * */
  useEffect(() => {
    if (accessToken) {
      getDelegationList();
      setIsSearch(false);
    }
  }, [accessToken, startRow, isSearch]);

  /*
  * When the editDelegation variable is changed, fetch the whole delegation object
  * */
  useEffect(() => {
    if (editDelegation !== '') {
      getDelegationInfo();
    }else{
      setContactData(defaultContactDelegation);
    }
  }, [editDelegation]);

  /*
  * When the delegation object is updated, check if its to delete it and then, if so update the delegation
  * */
  useEffect(() => {
    if (deleteDelegation === true) {
      handleCreateEditDelegation();
    }
  }, [contactData, deleteDelegation]);


  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to fetch the délégation list.
  * */
  function getDelegationList() {
    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setDelegations(response.payload.data.rows);
          setTotal(response.payload.data.searchTotal);
          setIsSearch(false);
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that handle the value changed on the search bar.
  * */
  function handleSearchChange(event) {
    const value = event.target.value;
    setInputSearchValue(value);
  }

  /*
  * Method that handle the click on the search Btn of the search bar.
  * */
  function handleSearchBtn(event){
    if (event.key === 'Enter' || event.type === "click") {
      setIsSearch(true);
      setStartRow(1);
    }
  }

  /*
  * Method to build the body array for the request.
  * */
  function buildMainBodyDataResquest() {
    let requestData = {
      maxRows: offset,
      startRow: startRow,
      ParameterValues: [""],
      matchCondition: 1,
      search: 'CSF_EP_UXDelegation_REST',
      searchResultsList: 'CSF_EP_UXDelegation_SRL'
    };

    let searchConditions = buildSearchConditionsContains(inputSearchValue, ["First_Name", "Last_Name"]);

    if (searchConditions.length > 0) {
      requestData.conditions = searchConditions;
    }

    return requestData;
  }

  /*
  * Method that handle de edit button on the table list and open the modal with the right information
  * */
  function handleModalClick(contactID) {
    // Reset errors and modal fields
    setIpfErrorMat(false);
    setIsError(false);
    setEditDelegation(null);

    setTimeout(()=>{ //timeout required to reset editDelegation
      setEditDelegation(contactID);
    },0);
  }

  /*
  * Method that handle de delete button on the table list
  * */
  function handleDeleteClick(contactID) {
    setDeleteType('delegation');
    setEditDelegation(contactID);
  }

  /*
  * Method that handle de delete button on the modal and delete a delegation
  * */
  function handleDeleteModal() {
    if (deleteType !== "") {
      setDeleteDelegation(true);
      setDeleteType('');
    }
  }

  function handleCancelModal() {
    setDeleteType('');
  }


  /*
  * Method to update the contactData object
  * */
  function updateContactData(data){
    setContactData(data);
  }

  /*
  * Method to fetch the delegation info.
  * */
  function getDelegationInfo() {
    const requestData = {
      form: 'CSF_EP_UXdelegation_Info',
      recordId: editDelegation
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.Contact_Id) {
          setContactData({
            'First_Name': response.payload.data.primary.First_Name !== null ? response.payload.data.primary.First_Name : "",
            'Last_Name': response.payload.data.primary.Last_Name !== null ? response.payload.data.primary.Last_Name : "",
            'GSFT_Correspondence_Language': response.payload.data.primary.GSFT_Correspondence_Language !== null ? response.payload.data.primary.GSFT_Correspondence_Language : 0,
            'Email': response.payload.data.primary.Email !== null ? response.payload.data.primary.Email : "",
            'EP_Contact_Role': response.payload.data.primary.EP_Contact_Role !== null ? response.payload.data.primary.EP_Contact_Role: 1,
            'GSFT_Status_Id': response.payload.data.primary.GSFT_Status_Id !== null ? response.payload.data.primary.GSFT_Status_Id : "AAAAAAAAADg=",
            'IPF_Matricule_Bridge': response.payload.data.primary.IPF_Matricule_Bridge !== null ? response.payload.data.primary.IPF_Matricule_Bridge : "",
          });
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to update or edit or soft delete a delegation
  * */
  function handleCreateEditDelegation() {
    const requestData = {
      form: 'CSF_EP_Delegation_UXContact_REST',
      deltaData: contactData
    };
    if (editDelegation !== '') {
      requestData.recordId = editDelegation;
    }
    if(deleteDelegation === true){
      requestData.deltaData.EP_Delegation_Deleted = true;
      setDeleteDelegation(false)
    }
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success) {
          setIsError(false);
          $("[data-dismiss=modal]").trigger({type: "click"});
          window.location.reload();
        } else {
          setIsError(true);
          stopLoadingSpinner();
          setIpfErrorMat(response.errorText?.includes("ERR_EP_IPF_MAT_01") ?? false);
          console.error(response.errorText);
        }
      })
      .catch(error => {
        setIsError(true);
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch(){
    setInputSearchValue("");
    setIsSearch(true);
    setStartRow(1);
  }


  return (
    <main className="fournisseur fournisseur-delegation">
      <div className="header-wrapper">
        <h1>{window.Drupal.t('fournisseur.delegation.title')}</h1>
      </div>

      <div className="primary">
        <div className="space-between-wrapper">
          <h2>{window.Drupal.t('fournisseur.delegation.list.title')}</h2>
        </div>

        <div className="inner-wrapper">
          <div className="search-container">
            <label htmlFor="delegationSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
            <input type="search" id="delegationSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                    placeholder={window.Drupal.t('fournisseur.search.placeholder')}/>
            <button className="search-close-icon btn-link"
                    aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                    onClick={(e) => {
                      clearSearchBtn(e, setInputSearchValue);
                      retriggerEmptySearch();
                    }}
            >
              <i className="icon icon-remove"></i>
            </button>
            <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                    title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
              <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <CsfPivotalFournisseurDelegationTable
            delegation={delegation}
            handleModalClick={handleModalClick}
            handleDeleteClick={handleDeleteClick}
          />

          <div className="pagination-wrapper space-between-wrapper smaller-wrapper">
            <CsfFournisseurPagination
              startRow={startRow}
              offset={offset}
              total={total}
              setStartRowFunction={setStartRow}
            />
            <div className="buttons-wrapper">
              <button onClick={() => handleClickLinks(urlHome)} className='button btn-outlined btn-larger' aria-label={window.Drupal.t('fournisseur.creation_form.form.backhome')}>
                {window.Drupal.t('fournisseur.previous.btn')}
              </button>

              <button className="button btn-with-icon btn-larger" onClick={() => handleModalClick("")} type="button"
                      data-toggle="modal" data-target="#delegationModal">
                <i className="icon icon-csf-plus"><span className="d-none">&nbsp;</span></i>
                {window.Drupal.t('fournisseur.delegation.add btn')}
              </button>
            </div>
          </div>
        </div>
      </div>

    <CsfPivotalFournisseurDelegationModal
      editDelegation={editDelegation}
      contactData={contactData}
      updateContactData={updateContactData}
      handleCreateEditDelegation={handleCreateEditDelegation}
      ipfErrorMat={ipfErrorMat}
      isError={isError}
      setIsError={setIsError}
      setIpfErrorMat={setIpfErrorMat}
    />

    <CsfPivotalFournisseurDeleteModal
      deleteType={deleteType}
      handleDeleteModal={handleDeleteModal}
      handleCancelModal={handleCancelModal}
    />

    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalFournisseurDelegation');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlHome = domNode.getAttribute("data-url-home");

    root.render(<CsfPivotalFournisseurDelegation
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlHome={urlHome}
    />);
  }
});

CsfPivotalFournisseurDelegation.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlHome: PropTypes.string,
};
